import { Component, Input } from '@angular/core';
import { GeneralCatalogViewModel } from 'src/app/model/general/general-catalog.view';

@Component({
  selector: 'ms-consult-catalog-item-readonly',
  templateUrl: './item-readonly.component.html',
})
export class GeneralConsultCatalogItemReadonlyComponent {
  @Input() readonly = false;
  @Input() catalog: GeneralCatalogViewModel = {};
}
